import { NgModule } from '@angular/core';
import { CoreJssUtilsModule, provideLazyLoad } from '@core/jss-utils';
import { CommonUiProductsModule } from '@innogy/common-ui/products';
import { CommonUiProgressiveFormsModule } from '@innogy/common-ui/progressive-forms';
import { CommonUiSalesModule } from '@innogy/common-ui/sales';
import {
  DefaultComponentModule,
  DefaultFormComponentModule,
} from '@innogy/core/modules/components';
import { FehSharedLazyModule } from '@innogy/feh/shared';
import { SharedProgressiveFormSitecoreModule } from '@innogy/shared/progressive-form/sitecore';
import { SitecoreFormsModule } from '@innogy/sitecore-forms';
import { CommonUiPartialsModule } from '@legacy/common-ui-partials';
import {
  NgbCollapseModule,
  NgbModalModule,
  NgbProgressbarModule,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { LoadingScreenComponent } from '@feh/shared-ui';

import {
  SolarPanelsOrderFormComponent,
  SolarPanelsOrderFormContainerComponent,
  SolarPanelsProductInfoComponent,
  SolarPanelsProductOverviewContainerComponent,
  SolarPanelsPropositionBoxComponent,
  SolarPanelsReceiptContainerComponent,
  SolarPanelsResultOverviewContainerComponent,
  SolarPanelsResultOverviewMapComponent,
  SolarPanelsResultOverviewSummaryContainerComponent,
  SolarPanelsSuitabilityCheckComponent,
  SolarPanelsSuitabilityCheckContainerComponent,
  SolarPanelsWizardContainerComponent,
} from './components';

@NgModule({
  imports: [
    DefaultComponentModule,
    DefaultFormComponentModule,
    CommonUiProductsModule,
    CommonUiPartialsModule,
    SitecoreFormsModule,
    NgbProgressbarModule,
    NgbCollapseModule,
    SharedProgressiveFormSitecoreModule,
    FehSharedLazyModule,
    NgbCollapseModule,
    TranslatePipe,
    TranslateDirective,
    CommonUiSalesModule,
    NgbModalModule,
    CoreJssUtilsModule,
    CommonUiProgressiveFormsModule,
    LoadingScreenComponent,
    provideLazyLoad({
      SolarPanelsWizard: SolarPanelsWizardContainerComponent,
      SolarPanelsSuitabilityCheck:
        SolarPanelsSuitabilityCheckContainerComponent,
      SolarPanelsProductOverview: SolarPanelsProductOverviewContainerComponent,
      SolarPanelsOrderForm: SolarPanelsOrderFormContainerComponent,
      SolarPanelsReceipt: SolarPanelsReceiptContainerComponent,
      SolarPanelsResultOverview: SolarPanelsResultOverviewContainerComponent,
      SolarPanelsResultOverviewSummary:
        SolarPanelsResultOverviewSummaryContainerComponent,
    }),
  ],
  declarations: [
    SolarPanelsOrderFormContainerComponent,
    SolarPanelsOrderFormComponent,
    SolarPanelsProductOverviewContainerComponent,
    SolarPanelsProductInfoComponent,
    SolarPanelsReceiptContainerComponent,
    SolarPanelsSuitabilityCheckContainerComponent,
    SolarPanelsWizardContainerComponent,
    SolarPanelsSuitabilityCheckComponent,
    SolarPanelsResultOverviewContainerComponent,
    SolarPanelsResultOverviewMapComponent,
    SolarPanelsResultOverviewSummaryContainerComponent,
    SolarPanelsPropositionBoxComponent,
  ],
  exports: [SolarPanelsSuitabilityCheckComponent],
})
export class SolarPanelsLazyModule {}
